export default __webpack_public_path__ + "static/media/cdn_hot.b560f873.png";